import React from 'react';
import PathologyResearchDetails from './Components/PathologyResearchDetails';

const PathologyResearcheDetailsPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <PathologyResearchDetails />
      </div>
    </div>
  );
};

export default PathologyResearcheDetailsPage;
